<style scoped>
</style>

<template>
  <section class="container">
      <portal-box>
        <h1 slot="titulo" class="title">Material de apoio</h1>
        <div slot="menu">
          <button class="button is-light" :class="{'is-loading': loading}" @click="buscarMaterialApoio()">
            <b-icon icon="refresh" />
          </button>
        </div>
        <div class="columns">
          <div class="column">
            <nav class="panel" >
              <p class="panel-heading">
                Inspiracional
              </p>
              <portal-loading-small :loading="loading" class="p-h-xl" />
              <template v-for="institucional in materialInstitucional" v-if="!loading">
                <a class="panel-block" target="_blank"
                   :href="institucional.link">
                <span class="panel-icon">
                  <b-icon icon="file-pdf"/>
                </span>
                  {{institucional.nome}}
                </a>
              </template>
            </nav>
          </div>
          <div class="column">
            <nav class="panel" >
              <p class="panel-heading">
                Vendas
              </p>
              <portal-loading-small :loading="loading" class="p-h-xl" />
              <template v-for="venda in materialVenda" v-if="!loading">
                <a class="panel-block" target="_blank"
                   :href="venda.link">
                <span class="panel-icon">
                  <b-icon icon="file-pdf"/>
                </span>
                  {{venda.nome}}
                </a>
              </template>
            </nav>
          </div>
        </div>
      </portal-box>
  </section>

</template>

<script>
  export default {
    created () {
      this.buscarMaterialApoio()
    },
    data () {
      return {
        loading: false,
        materialInstitucional: [],
        materialVenda: []
      }
    },
    mounted () {
      let possuiPermissao
      this.$store.state.menu.forEach(item => {
        if (item.sub_menus.filter(sub => sub.link === '/material_apoio').length > 0) {
          possuiPermissao = true
        }
      })
      if (!possuiPermissao) {
        this.$router.push('/403')
      }
    },
    methods: {
      buscarMaterialApoio () {
        this.loading = true
        this.$http.get(this.$URL.DOWNLOAD.MATERIAL_APOIO, this.$header()).then(res => {
          this.loading = false
          this.materialInstitucional = res.body.filter(inst => inst.tipo === 'INSPIRACIONAL')
          this.materialVenda = res.body.filter(inst => inst.tipo === 'VENDAS')
        }, res => {
          this.loading = false
          let msg = res.body.message ? res.body.message : res.body
          this.$toast.open({
            message: msg,
            type: 'is-danger',
            duration: 4 * 1000
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/download/DetalheMaterialApoio.vue